/*eslint no-unused-vars:0 no-trailing-spaces:0 */
/*globals localStorage*/
var _ = require("ES/lib/lodash");
var dd = require("ES/lib/dd");
var Modal = require("ES/widgets/Modal");
var esUtils = require("ES/utils/esUtils");
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var radio = require("ES/lib/react-pubsub-via-radio.js/radio");
var RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
var ProOnly = require("../../../../widgets/ProOnly");

var serviceFee = function(service){
	if(!service){
		return "";
	}
	if(_.includes(service.flags, "FREE")){
		return "Free";
	}else if(_.includes(service.flags, "BILL_LATER")){
		return "Actual";
	}
	return esUtils.format_currency(service.fee, 2);
};

var numberOrZero = function(n){
	var q = parseFloat(n);
	return _.isNaN(q) ? 0 : q;
};

module.exports = dd.createClass({
	mixins: [RadioServiceMixin],
 	RadioService_setup: function() {
		return {
			Quickbooks_findCustomerByName: {
				key: function() {
					return 1;
				},
				on: {
					succeeded: function(data) {
						// send to connection page now since they aren't connected yet
						if ( data.data && data.data.is_connected === false ) {
							// set current EID in local storage first
							localStorage.setItem('origin_eid', this.props.event.eid);
							window.location.hash = '#/account_settings/connect/_/' + this.state.sid + '/quickbooks';
						}
						// save customer id in state if we found one
						if ( data.data && data.data.customer ) {
							this.setState({customer_id: data.data.customer.id});
						}
					}
				}
			},
			Quickbooks_createInvoice: {
				key: function() {
					return 1;
				}
			},
			Quickbooks_addInvoiceToQueue: {
				key: function() {
					return 1;
				}
			}
		};
	},
	getInitialState: function() {
		return {
			connection_type: localStorage.getItem('connection_type') ? localStorage.getItem('connection_type') : null,
			connection_type_set: localStorage.getItem('connection_type') ? true : false,
			sid: -1,
			create_customer: true,
			customer_id: 0,
			hide_notice: localStorage.getItem('hide_notice') ? true : false,
			desktop_notice_shown: localStorage.getItem('desktop_notice_shown') === null || localStorage.getItem('desktop_notice_shown') == 'true' ? true : false,
			services: this.props.event.Service,
			products: this.props.event.ProductSale
		};
	},
	componentDidMount: function() {
		this.__loadForSid(this.props.event.sids[0]);
	},
	__loadForSid: function(sid){
		if ( sid != this.state.sid ) {
			this.setState({sid: sid}, function() {
				var type = this.state.connection_type;
				if ( type == 'online' ) {
					radio('Quickbooks_findCustomerByName').broadcast({sid: sid, name: this.props.event.organization});
				}
			});
		}
	},
	__toggleCreateCustomer: function() {
		this.setState({create_customer: !this.state.create_customer});
	},
	__hideDesktopNotice: esUtils.wrapPreventDefault(function(e) {
		this.setState({desktop_notice_shown: false});
		localStorage.setItem('desktop_notice_shown', false);
	}),
	__showDesktopNotice: esUtils.wrapPreventDefault(function(e) {
		this.setState({desktop_notice_shown: true});
		localStorage.setItem('desktop_notice_shown', true);
	}),



	__connectionTypeSelected: function(type) {
		this.setState({connection_type: type});
	},
	__setConnectionType: function() {
		var type = this.state.connection_type;
		this.setState({connection_type_set: true});
		localStorage.setItem('connection_type', type);
		if ( type == 'online' ) {
			radio('Quickbooks_findCustomerByName').broadcast({sid: this.state.sid, name: this.props.event.organization});
		}

	},
	__resetConnectionType: esUtils.wrapPreventDefault(function(e) {
		localStorage.removeItem('connection_type');
		this.setState({connection_type: null});
		this.setState({connection_type_set: false});
	}),



	__updateSelectedItems: function(id, item) {
		var allItems, selectedItems;
		var newItems = [];
		var isSelected = false;
		if ( item == 'service' ) {
			allItems = this.props.event.Service;
			selectedItems = this.state.services;
		} else if ( item == 'product' ) {
			allItems = this.props.event.ProductSale;
			selectedItems = this.state.products;
		}

		selectedItems = _.isEmpty(selectedItems) ? []  : selectedItems;
		// loop over our current selected items
		_.forEach(selectedItems, function(item) {
			if ( item.id == id ) {
				isSelected = true;
			} else {
				newItems.push(item);
			}
		});
		// add the item if it wasn't found in selected array
		if ( !isSelected ) {
			_.forEach(allItems, function(item) {
				if ( item.id == id ) {
					newItems.push(item);
				}
			});
		}
		// set new items state
		if ( item == 'service' ) {
			this.setState({services: newItems});
		} else if ( item == 'product' ) {
			this.setState({products: newItems});
		}
	},
	__createInvoice: function() {

		if ( this.state.disable_notice ) {
			localStorage.setItem('hide_notice', true);
		}

		// broadcast our radio event with state data
		var service = this.state.connection_type == 'desktop' ? 'Quickbooks_addInvoiceToQueue' : 'Quickbooks_createInvoice';
		radio(service).broadcast({
			sid: this.state.sid,
			name: this.props.event.organization,
			customer_id: this.state.customer_id,
			services: JSON.stringify(this.state.services),
			products: JSON.stringify(this.state.products)
		});

	},
	render: function() {

		var connectionType = this.state.connection_type;
		var connectionTypeSet = this.state.connection_type_set;
		var desktopNoticeShown = this.state.desktop_notice_shown;

		/*****/

		var ajax2 = this.state.Quickbooks_findCustomerByName;
		var ajax3 = this.state.Quickbooks_createInvoice;
		var ajax4 = this.state.Quickbooks_addInvoiceToQueue;

		var loadingText;
		if ( ajax2.waiting ) {
			loadingText = 'Connecting to QuickBooks Online...';
		}
		if ( ajax3.waiting ) {
			loadingText = 'Creating QuickBooks Online Invoice...';
		}
		if ( ajax4.waiting ) {
			loadingText = 'Sending Invoice to QuickBooks Desktop...';
		}
		var checkedStatus = (ajax3.error !== null && ajax3.error.indexOf('at least') > -1) || (ajax4.error !== null && ajax4.error.indexOf('at least') > -1) ? false : true;
		var isWaiting = ajax2.waiting || ajax3.waiting || ajax4.waiting;
		var isConnected = ajax2.data && ajax2.data.data.is_connected ? true : false;
		var event = this.props.event;
		var services = event.Service;
		var products = event.ProductSale;
		var customer = ajax2.data ? ajax2.data.data.customer : null;
		var invoiceCreated = (ajax3.data && ajax3.data.data.invoice_id) || (ajax4.data && ajax4.data.data.queue_id) ? true : false;
		var desktopCreate = connectionType == 'desktop' ? true : false;
		var invoiceQueued = false;

		if ( desktopCreate ) {
			isConnected = true;
			invoiceQueued = invoiceCreated ? true : false;
			invoiceCreated = false;
			customer = null;
		}

		let {onClose} = this.props;
		return Modal({
				title: 'Create Invoice in QuickBooks',
				onClose,
				buttons: (!connectionTypeSet ? [
					{
						name: 'Continue',
						className: 'btn btn-primary ' + (connectionType === null ? 'disabled' : ''),
						onClick: this.__setConnectionType
					}
				] : (invoiceCreated || invoiceQueued ? [
	                {
                        name: 'Okay',
                        className: 'btn btn-default',
                        onClick: onClose
                    }
                ] : [
                	{
                        name: 'Cancel',
                        className: 'btn btn-default',
                        onClick: onClose
                    },
                    {
                        name: 'Save',
                        className: 'btn btn-primary' + (!this.state.create_customer || isWaiting || invoiceCreated || invoiceQueued ? ' disabled' : ''),
                        onClick: (!this.state.create_customer ? null : this.__createInvoice)
                    }
                ]))
			},
			dd.div({className: "row"},
				LoadingWrap({is_loading: isWaiting, text: loadingText},
					ErrorAlert({message: ajax2.error}),
					ErrorAlert({message: ajax3.error}),
					ErrorAlert({message: ajax4.error}),

					ProOnly({sids: event.sids},

						!connectionTypeSet ? dd.div({className: 'col-sm-12'},
							dd.div({className: 'alert alert-info'},
								'It looks like you haven\'t selected a QuickBooks connection type yet.  Please choose one of the options below to continue.'
							),
							dd.div({className: "row"},
								dd.div({className: "col-sm-6 text-center"},
									dd.div({className: 'radio'},
										dd.label(null,
											dd.input({type: 'radio', 'name': 'connection_type', style: {float: 'none'}, defaultChecked: false, onChange: this.__connectionTypeSelected.bind(this, 'online')}),
											dd.span({style: {fontSize: '18px'}}, ' QuickBooks Online')
										)
									)
								),
								dd.div({className: "col-sm-6 text-center"},
									dd.div({className: 'radio'},
										dd.label(null,
											dd.input({type: 'radio', 'name': 'connection_type', style: {float: 'none'}, defaultChecked: false, onChange: this.__connectionTypeSelected.bind(this, 'desktop')}),
											dd.span({style: {fontSize: '18px'}}, ' QuickBooks Desktop')
										)
									)
								)
							)
						) : dd.div({className: 'col-sm-12'},

							// show success message if invoice was created
							invoiceCreated ? dd.div(null,

								dd.div({className: 'alert alert-success'},
									'A new invoice within your QuickBooks account has been created successfully!'
								)

							) : (invoiceQueued ? dd.div(null,

								dd.div({className: 'alert alert-success'},
									dd.strong(null, 'A new invoice has been queued for creation!'),
									dd.br(null),
									dd.small(null, 'The next time that your QuickBooks Web Connector software runs the eSpeakers QWC application, the queued invoice will be created within your QuickBooks software.  If the invoice does not get created, the most likely cause of failure is having a service/product on your invoice that does not match an item within your QuickBooks software exactly.')
								)

							) : dd.div(null,

								// determine if we found a matching customer or not
								desktopCreate ? dd.div(null,
									(!this.state.hide_notice ? dd.div({className: 'alert alert-warning', style: {marginBottom: '15px', fontSize: '13px'}},
										dd.div({className: 'row'},
											dd.div({className: 'col-sm-6'},
												dd.strong(null, 'Desktop Notice')
											),
											dd.div({className: 'col-sm-6', style: {textAlign: 'right'}},
												desktopNoticeShown ? dd.a({href: '#', onClick: this.__hideDesktopNotice}, '- collapse') : dd.a({href: '#', onClick: this.__showDesktopNotice}, '+ expand')
											)
										),
										(desktopNoticeShown ? dd.div({style: {marginTop: '10px'}},
											dd.p(null, 'In order to create an invoice within your QuickBooks desktop software, the following conditions must be met:'),
											dd.ul({style: {marginTop: '10px', marginBottom: '10px'}},
												dd.li(null,
													'Have the Quickbooks Web Connector software installed and configured. For help, please see the following wiki article: ',
													dd.a({href: 'https://www.espeakers.com/wiki/Connect_Quickbooks_to_your_EventCX_account', target: '_blank'}, 'https://www.espeakers.com/wiki/Connect_Quickbooks_to_your_EventCX_account')
												),
												dd.li(null,
													'If you do not have an existing customer within your QuickBooks software that matches the customer name shown below ', dd.strong(null, 'exactly'), ', then a new customer with that name will be created automatically.'
												),
												dd.li(null,
													'For each service/product that you select below, ', dd.strong({className: 'text-danger'}, 'you must have an existing item (or items) within your QuickBooks software that matches the service/product CODE exactly'), ', otherwise the invoice will NOT be created.'
												)
											)
										) : '')
									) : ''),
									dd.div(null,
										'Customer: ',
										dd.strong(null, event.organization)
									)
								) : (customer && customer.name ? dd.div(null,
										dd.div({className: 'text-success'},
											'Matching QuickBooks customer found: ', dd.strong(null, customer.name)
										)
									) : dd.div(null,
										dd.div({className: 'text-warning'},
											dd.strong(null, event.organization), ' was not found in your Quickbooks customers list.'
										),
										dd.div(null,
											dd.input({className: '', type: 'checkbox', defaultChecked: true, onChange: this.__toggleCreateCustomer}),
											dd.small(null, ' Yes, I would like to create a new QuickBooks customer using this name.')
										),
										this.state.create_customer ? null : dd.div({className: 'text-muted'},
											dd.small(null, '(If you do not want to create a new QuickBooks customer, you must instead change the event PRESENTING TO field so it exactly matches a customer name in your QuickBooks account.)')
										)
									)
								),
								dd.hr(),


								dd.h5({style: {marginTop: '30px'}}, 'Select service(s) to include on invoice:'),
								// show services table
								dd.table({className: 'table table-responsive table-condensed'},
									dd.thead(null,
										dd.tr(null,
											dd.th({style: {width: 1}}, ''),
											dd.th({style: {width: 1}}, 'Code'),
											dd.th({style: {width: 1}}, 'Due'),
											dd.th(null, 'Description'),
											dd.th({style: {width: 1}}, 'Amount')
										)
									),
									_.isEmpty(services) ? null : dd.tbody(null,
										_.map(services, function(service){
											return dd.tr({key: service.id, className: ''},
												dd.td(null, dd.input({type: 'checkbox', defaultChecked: checkedStatus, onChange: this.__updateSelectedItems.bind(this, service.id, 'service')})),
												dd.td(null, service.groupcode),
												dd.td(null, !service.due ? '' : esUtils.format_date(service.due, 'mm/dd/yyyy')),
												dd.td(null, service.description),
												dd.td(null, serviceFee(service))
											);
										}, this)
									),
									_.isEmpty(services) ? dd.tbody(null,
										dd.tr(null,
											dd.td({colSpan: 5, style: {textAlign: 'center'}},
												'-- no services --'
											)
										)
									) : null
								),


								dd.h5({style: {marginTop: '30px'}}, 'Select product(s) to include on invoice:'),
								// show products table
								dd.table({className: 'table table-responsive table-condensed'},
									dd.thead(null,
										dd.tr(null,
											dd.th({style: {width: 1}}, ''),
											dd.th({style: {width: 1}}, "Code"),
											dd.th({style: {width: 1}}, "Qty"),
											dd.th(null, "Description"),
											dd.th({style: {width: 1}}, "Price")
										)
									),
									_.isEmpty(products) ? null : dd.tbody(null,
										_.map(products, function(product){
											return dd.tr({key: product.id, className: ''},
												dd.td(null, dd.input({type: 'checkbox', defaultChecked: checkedStatus, onChange: this.__updateSelectedItems.bind(this, product.id, 'product')})),
												dd.td(null, product.groupcode),
												dd.td(null, numberOrZero(product.qtysold)),
												dd.td(null, product.description),
												dd.td(null, esUtils.format_currency(numberOrZero(product.priceeach), 2))
											);
										}, this)
									),
									_.isEmpty(products) ? dd.tbody(null,
										dd.tr(null,
											dd.td({colSpan: 5, style: {textAlign: 'center'}},
												'-- no products --'
											)
										)
									) : null
								),

								dd.div({style: {marginTop: '50px', marginBottom: '-70px', float: 'left'}},
									dd.small({className: 'text-muted'},
										'connection type: ' + connectionType + ' (',
										dd.a({href: '#', className: 'text-muted', onClick: this.__resetConnectionType}, dd.u(null, 'change')),
										')'
									)
								)

							))

						)

					)
				)
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/QuickBooks.js